import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LegalFooter } from '../legal/LegalLinks';
import { useFreeAuth } from './FreeAuth';

export default function FreeAccountDeleted() {
  const { state } = useLocation();
  const { markSignedOut } = useFreeAuth();
  const deleted = Boolean(state?.deleted);

  useEffect(() => {
    if (deleted) markSignedOut();
  }, [deleted, markSignedOut]);

  return (
    <div className="min-h-screen bg-mono-base flex flex-col" data-testid="free-account-deleted-page">
      <main className="flex-1 flex items-center">
        <div className="max-w-lg w-full mx-auto px-6 py-16">
          <span className="text-mono-mute font-heading text-sm font-bold uppercase tracking-[0.3em]">Coach Rands Method</span>
          <h1 className="font-heading text-4xl sm:text-5xl font-black uppercase tracking-tight text-white leading-none mt-6 mb-5" data-testid="account-deleted-title">
            Your account has been deleted
          </h1>
          <p className="text-mono-mute font-body leading-relaxed mb-4">
            We have permanently removed your account, your logged sessions, your check-ins and any login links from
            our database. You have been signed out.
          </p>
          {state?.email && (
            <p className="text-mono-mute font-body leading-relaxed mb-8" data-testid="account-deleted-email-note">
              {state.emailSent
                ? `A confirmation email is on its way to ${state.email}.`
                : 'We could not send the confirmation email, but your account has still been deleted.'}
            </p>
          )}
          <Link to="/free" className="inline-block bg-white hover:bg-[#E5E5E5] text-black font-heading font-bold uppercase tracking-wider rounded-none px-8 py-3 transition-colors" data-testid="account-deleted-home-btn">
            Back to the start
          </Link>
        </div>
      </main>
      <LegalFooter />
    </div>
  );
}
